import { render, staticRenderFns } from "./ActiveAlertLongStayList.vue?vue&type=template&id=b467d208&scoped=true&lang=pug"
import script from "./ActiveAlertLongStayList.vue?vue&type=script&lang=ts"
export * from "./ActiveAlertLongStayList.vue?vue&type=script&lang=ts"
import style0 from "./ActiveAlertLongStayList.vue?vue&type=style&index=0&id=b467d208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b467d208",
  null
  
)

export default component.exports